import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";

import { TechCommunity } from "api/memberPortal/techCommunities/techCommunities.types";
import EmailCell from "components/MUI/DataGrid/Cells/Email.cell";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";

export const getTechnicalCommunitiesColumns = (
  onEdit: (_tc: TechCommunity) => void,
): GridColDef<TechCommunity>[] => [
  { field: "community_name", headerName: "Name", flex: 1 },
  {
    field: "contact_email",
    headerName: "Alias",
    flex: 1,
    renderCell: ({ row }) => <EmailCell email={row.contact_email} />,
  },
  {
    field: "url",
    headerName: "Website",
    flex: 1,
    renderCell: ({ row }) => <LinkCell to={row.url} label={row.url} external />,
  },
  {
    field: "is_international",
    headerName: "ITC",
    flex: 0.5,
    valueFormatter: (value: boolean) => (value ? "Yes" : "No"),
  },
  {
    field: "actions",
    headerName: "Actions",
    flex: 0.5,
    sortable: false,
    filterable: false,
    renderCell: ({ row }) => (
      <Button
        variant="outlined"
        size="small"
        startIcon={<Edit />}
        onClick={() => onEdit(row)}
      >
        Edit
      </Button>
    ),
  },
];
